// https://github.com/ljharb/proposal-is-error
var $export = require('./_export')
  , cof     = require('./_cof');

$export($export.S, 'Error', {
  isError: function isError(it){
    return cof(it) === 'Error';
  }
});


//////////////////
// WEBPACK FOOTER
// /~/babel-polyfill/~/core-js/modules/es7.error.is-error.js
// module id = 1049
// module chunks = 0